import { saveCookie, readCookie } from "./../../../utils/cookies";

const STORAGE_KEY = "closeAlert";
const ALERTBAR_SELECTOR = ".alertbar";
const BODY_CLASS_INDICATOR_VISIBLE = "alert-bar--visible";
const BODY_CLASS_INDICATOR_INVISIBLE = "alert-bar--not-visible";

function isAlertbarPresentFromBackend(): boolean {
  return document.querySelector(ALERTBAR_SELECTOR) !== null;
}

function shouldHide(id: string) {
  const storage = readCookie(STORAGE_KEY);
  if (storage === null) {
    return false;
  }
  return storage.split(",").includes(id);
}

function hideClosedBars(): boolean {
  let hideAll = true;
  const alertBars = document.querySelectorAll<HTMLDivElement>(ALERTBAR_SELECTOR);
  alertBars.forEach((bar) => {
    if (shouldHide(bar.id)) {
      bar.style.display = "none";
    } else {
      hideAll = false;
    }
  });
  return hideAll;
}

function handleCloseClick(closeBtn: HTMLButtonElement) {
  const alertbar = closeBtn.closest(ALERTBAR_SELECTOR) as HTMLDivElement;

  let idsToHide = [alertbar.id];
  const storageValues = localStorage.getItem(STORAGE_KEY);
  if (storageValues) {
    idsToHide = [...idsToHide, ...storageValues.split(",")];
  }
  saveCookie(STORAGE_KEY, idsToHide.join(","));

  alertbar.classList.add("alertbar-hide");
  document.body.classList.remove(BODY_CLASS_INDICATOR_VISIBLE);
}

function AlertBarNew() {
  document.body.classList.add(BODY_CLASS_INDICATOR_INVISIBLE);

  if (!isAlertbarPresentFromBackend()) {
    return;
  }

  const hideAll = hideClosedBars();
  if (hideAll) {
    return;
  }

  document.body.classList.remove(BODY_CLASS_INDICATOR_INVISIBLE);
  document.body.classList.add(BODY_CLASS_INDICATOR_VISIBLE);

  document.addEventListener("click", (e) => {
    const target = e.target;
    if (!(target instanceof Element)) {
      return;
    }
    const btn = target.closest("button");
    if (btn instanceof HTMLButtonElement) {
      if (btn.classList.contains("alertbar-close")) {
        handleCloseClick(btn);
      }
    }
  });
}
AlertBarNew();
